
import { NavLink } from "@/components/NavLink";
import { Instagram, Phone, Mail } from "lucide-react";
const currentYear = new Date().getFullYear();
const SiteFooter = () => {
  return <footer className="footer-shell">
      <div className="container-page py-10 md:py-12">
        <div className="grid gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)] md:items-start">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-footer-soft">
                <img alt="Logotipo do Instituto Evangelístico e Social Sabedoria do Alto" className="h-7 w-7 object-contain" loading="lazy" width={28} height={28} src="/lovable-uploads/372b8508-00de-4a16-ba29-385a6e052d4d.png" />
              </div>
              <div className="text-sm text-footer-strong">
                <p className="font-semibold uppercase tracking-[0.2em]">IESSA</p>
                <p>Plantando evangelho e regando esperança.</p>
              </div>
            </div>
            <p className="max-w-md text-sm text-footer-muted">
              Instituto evangelístico e social comprometido com a pregação do evangelho, formação teológica e cuidado
              integral de pessoas, especialmente no sertão da Caatinga.
            </p>
          </div>

          <div className="space-y-3 text-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary">Institucional</p>
            <ul className="space-y-2 text-footer-muted">
              <li>
                <FooterLink to="/missao">Missão e Visão</FooterLink>
              </li>
              <li>
                <FooterLink to="/missoes-caatinga">Projeto Missões Caatinga</FooterLink>
              </li>
              <li>
                <FooterLink to="/teologia">Curso de Teologia</FooterLink>
              </li>
              <li>
                <FooterLink to="/sobre">Sobre o Instituto</FooterLink>
              </li>
            </ul>
          </div>

          <div className="space-y-3 text-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary">Contato</p>
            
            <p className="text-footer-muted">Endereço: Rua Bento Pereira, S/N Vila Cardoso. Caldeirão Grande - BA</p>
            <div className="mt-2 flex items-center gap-3 text-footer-link">
              <a href="https://www.instagram.com/iessa.instituto/" target="_blank" rel="noreferrer" aria-label="Instagram do Instituto" className="hover-scale">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://wa.me/5574981070229" target="_blank" rel="noreferrer" aria-label="WhatsApp do Instituto" className="hover-scale">
                <Phone className="h-5 w-5" />
              </a>
              <a href="mailto:iessa.institutoevangelistico@gmail.com" aria-label="Enviar email para o Instituto" className="hover-scale">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-footer-divider pt-6 text-xs text-footer-muted md:flex-row md:items-center md:justify-between">
          <p>
            © {currentYear} Instituto Evangelístico e Social Sabedoria do Alto. Todos os direitos reservados.
          </p>
          <p>Plantando evangelho e regando esperança!.</p>
        </div>
      </div>
    </footer>;
};
interface FooterLinkProps {
  to: string;
  children: React.ReactNode;
}
const FooterLink = ({
  to,
  children
}: FooterLinkProps) => <NavLink to={to} className="text-footer-link hover:text-secondary">
    {children}
  </NavLink>;
export default SiteFooter;